module.exports = __webpack_public_path__ + "static/media/siar_logo.caac3373.png";